export const ACCESS_CONTROLS_RESET_STATE = 'ACCESS_CONTROLS_RESET_STATE';
export const ACCESS_CONTROLS_CURRENT_ITEM = 'ACCESS_CONTROLS_CURRENT_ITEM';

export const ACCESS_CONTROLS_REQUEST_LOADING = 'ACCESS_CONTROLS_REQUEST_LOADING';
export const ACCESS_CONTROLS_REQUEST_SUCCESS = 'ACCESS_CONTROLS_REQUEST_SUCCESS';
export const ACCESS_CONTROLS_REQUEST_FAILED = 'ACCESS_CONTROLS_REQUEST_FAILED';

export const ACCESS_CONTROLS_CURRENT_ACTION = 'ACCESS_CONTROLS_CURRENT_ACTION';
export const ACCESS_CONTROLS_RESET_ACTION = 'ACCESS_CONTROLS_RESET_ACTION';